import React from 'react';
import styled from 'styled-components';
import colors from '../styles/colors';

const Logo = styled.div`
  height: 100px;
  width: 100px;
  border-radius: 50%;
  margin-right: 15px;
  background-color:${colors.white};
  border: 1px solid ${colors.grey5};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  @media screen and (max-width: 991px) {
    height: 70px;
  width: 70px;
  margin-bottom:-50px;
  }
`;

const ImageContainer = styled.img`
  width: 100%;
  height: auto;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  @media screen and (max-width: 991px){
   margin-bottom: 40px;
  }
`;

const InfoContainer = styled.div``;

const Name = styled.div`
  color: ${colors.white};
  font-weight: 600;
  font-size: 1.8rem;
  width:58vw;
`;

const Address = styled.div`
  color: ${colors.grey6};
  font-weight: 500;
  font-size: 1.4rem;
`;

export default function BusinessPreview({ organization }) {
  if (!organization) {
    return null;
  }

  const address = `${organization.address.city}, ${organization.address.state}`;
  return (
    <Container>
      <Logo>
        <ImageContainer src={organization.logoUrl} />
      </Logo>
      <InfoContainer>
        <Name>
          {organization.name}
        </Name>
        <Address>
          {address}
        </Address>
      </InfoContainer>
    </Container>
  );
}
